import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { NavLink } from "react-router-dom";
import PublIcon from '@material-ui/icons/Public';
import { useTranslation, Trans } from 'react-i18next';
import * as bottomBarActions from '../../constants/BottomBarActions';
//import history from '../../helpers/history';

const { t } = useTranslation();

class BottomBar extends Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLanguageChange = (newlang) => {
    this.props.i18n.changeLanguage(newlang);
    this.setState({ anchorEl: null });
  }

  setAction = () => {
    if(this.props.ShowBottomBarAction)
    {
      switch(this.props.BottomBarAction){
        case bottomBarActions.Actions.Home:
          this.props.History.push('/');
          return this.props.History.go();
        case bottomBarActions.Actions.Back:
          return this.props.History.goBack();
        default :
        this.props.History.push('/');
        return this.props.History.go();
      }
    }

    return this.props.History.goBack();
  };

  setActionButtonClass = () => {
    if(!this.props.ShowBottomBarAction) { 
      return "buttonAsNavLink hideDiv";
    }

    return "buttonAsNavLink";
  };

  render() {
    const { anchorEl } = this.state;    

    let actionButtonClass = this.setActionButtonClass();

    return (
        <div className="bottomContainer">
          <AppBar position="static">
            <Toolbar>
              <div className="helpContainer">
                <NavLink to="/help"><Trans>{t('Help')}</Trans></NavLink>
                </div>
                    <div className="homeContainer">
                      {/* <NavLink to={actionUrl} activeClassName={actionButtonClass}><Trans>{this.props.BottomBarActionTitle}</Trans></NavLink> */}
                      <Button onClick={() => this.setAction()} className={actionButtonClass} color="secondary" ><Trans>{this.props.BottomBarActionTitle}</Trans></Button>
                    </div>
                <div className="translationContainer">
                <Button
                  aria-owns={anchorEl ? 'simple-menu' : undefined}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                  className="languageButton"
                >
                  <PublIcon></PublIcon>
                  <Trans>{t('Language')}</Trans>
                </Button>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}>
                    <MenuItem onClick={() => this.handleLanguageChange('nl')}>Nederlands</MenuItem>
                  </Menu>
              </div>
            </Toolbar>
          </AppBar>
        </div>
      );
    }
}

export default BottomBar;